// src/helpers/validation-rules.js
export const validationRules = {
    emailRequired: [
        v => !!v || 'E-Mail Adresse wird benötigt',
        v => /.+@.+\..+/.test(v) || 'Gib eine gültige E-Mail Adresse an'
    ]
};